import { __rest } from "tslib";
import * as React from 'react';
const ReplySmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { d: "M5.5 3A1.5 1.5 0 004 4.5v6.98a1.5 1.5 0 001.5 1.5H7v2.288a.75.75 0 001.229.577l2.497-2.072-.639-.77L8 14.735v-2.204a.55.55 0 00-.55-.55H5.5a.5.5 0 01-.5-.5V4.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v2h1v-2A1.5 1.5 0 0014.5 3h-9z" }),
        React.createElement("path", { d: "M16.737 9.346L14.34 7.133l-.678.734 1.06.98H13a1.5 1.5 0 00-1.5 1.5V13.5h1v-3.154a.5.5 0 01.5-.5h1.721l-1.06.979.678.735 2.398-2.214z" })));
};
ReplySmall.displayName = 'ReplySmall';
export default ReplySmall;
//# sourceMappingURL=ReplySmall.js.map